import { Ruler } from "lucide-react";

/**
 * Reassuring banner shown on early steps so customers know
 * measurements come AFTER checkout — reduces drop-off.
 */
export default function MeasureLaterNote({ className = "" }) {
  return (
    <div
      data-testid="measure-later-note"
      className={`flex items-start gap-3 rounded-2xl p-3 mb-5 ${className}`}
      style={{ background: "var(--brand-green-light)", border: "1px solid #cbe3d2" }}
    >
      <Ruler className="w-4 h-4 mt-0.5 brand-text shrink-0" />
      <p className="text-xs leading-snug text-[var(--brand-text)]">
        <strong>No need to measure right now.</strong>{" "}
        We collect measurements <em>after</em> checkout — or send a link so you can do it later.
      </p>
    </div>
  );
}
